/**
 * ScandiPWA - Progressive Web App for Magento
 *
 * Copyright © Scandiweb, Inc. All rights reserved.
 * See LICENSE for license details.
 *
 * @license OSL-3.0 (Open Software License ("OSL") v. 3.0)
 * @package scandipwa/base-theme
 * @link https://github.com/scandipwa/base-theme
 */

import PropTypes from 'prop-types';
import { PureComponent } from 'react';

import Overlay from 'Component/Overlay';
import SearchItem from 'Component/SearchItem';
import { ItemsType } from 'Type/ProductList';

import {
    AMOUNT_OF_PLACEHOLDERS,
    SEARCH_TIMEOUT
} from './SearchOverlay.config';

import {SearchOverlay as SourceSearchOverlay} from 'SourceComponent/SearchOverlay/SearchOverlay.component';

/** @namespace Component/SearchOverlay/Component */
export class SearchOverlay extends SourceSearchOverlay {
    componentDidMount(){
        setTimeout(this.updateSearchStyle(), 
                    1000);
    }
    componentDidUpdate(prevProps) {
        const { searchCriteria: prevSearchCriteria } = prevProps;
        const { searchCriteria, clearSearchResults, makeSearchRequest } = this.props;

        if (searchCriteria !== prevSearchCriteria) {
            if (this.timeout) {
                clearTimeout(this.timeout);
            }
            clearSearchResults();
            this.timeout = setTimeout(() => {
                this.timeout = null;
                makeSearchRequest();
            }, SEARCH_TIMEOUT);
        }
        this.updateSearchStyle();
    }

    updateSearchStyle() {
        let searchField = document.getElementById('SearchField');
        let searchOverlay = document.getElementById('SearchOverlay');
        let searchOffsetRight = 0;

        if(searchField) {
            searchOffsetRight = window.innerWidth - searchField.offsetLeft - searchField.offsetWidth;
        }

        if(searchOverlay && !searchOverlay.classList.contains('active') && window.innerWidth > 810 && window.innerWidth < 1025){
            searchOverlay.classList.add('active');
            searchOverlay.style.width = (window.innerWidth) + 'px';
            searchOverlay.style.marginRight = '-' + searchOffsetRight + 'px';
        }
    }

    render() {
        const { isHideOverlay, searchCriteria } = this.props;

        // if (!searchCriteria.trim()) {
        //     return null;
        // }

        if (isHideOverlay) {
            return (
                <article
                    block="SearchOverlay"
                    elem="Results"
                    aria-label="Search results"
                    id="SearchOverlay"
                >
                    { this.renderSearchResults() }
                </article>
            );
        }

        return (
            <Overlay
                id="search"
                mix={ { block: 'SearchOverlay' } }
            >
                <article
                    block="SearchOverlay"
                    elem="Results"
                    aria-label="Search results"
                    id="SearchOverlay"
                >
                    { this.renderSearchResults() }
                </article>
            </Overlay>
        );
    }
}

export default SearchOverlay;
